import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import AnnouncementBar from "./components/AnnouncementBar";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import PreOrderCheckoutPage from "./pages/PreOrderCheckoutPage";
import PreOrderSuccessPage from "./pages/PreOrderSuccessPage";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
        <AnnouncementBar />
        <Navbar />
        <CartDrawer />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/checkout" element={<PreOrderCheckoutPage />} />
          <Route path="/preorder-success" element={<PreOrderSuccessPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              fontFamily: "'Avega', sans-serif",
              fontStyle: "italic",
              borderRadius: "0",
            },
          }}
        />
      </BrowserRouter>
    </CartProvider>
    </HelmetProvider>
  );
}

export default App;
